export const GETTERS = {
  LOADING: 'loading',
  APP_INITIALIZED: 'initialized',
  CAN_ACCESS_APPLICATION_ACCOUNTS: 'canAccessApplicationAccounts',
  USER_ORGANISATION_IS_MASTER: 'userOrganisationIsMaster',
  USER_DISPLAY_NAME: 'userDisplayName',
  USER_ORGANISATIONS_NAMES: 'userOrganisationsNames',
  USER_CAN_MARK_PAYMENT_AS_EXECUTED: 'userCanMarkPaymentAsExecuted',
  USER_CAN_MASS_DELETE_SETTLEMENTS: 'userCanMassDeleteSettlements',
  USER_CAN_SEND_SETTLEMENTS_EMAILS_TO_DRIVERS: 'userCanSendSettlementsEmailsToDrivers',
  USER_HAVE_ACCESS_TO_AUDIT_AREA: 'userHaveAccessToAuditArea',
  USER_CAN_DELETE_DRIVERS: 'userCanDeleteDrivers',
  USER_CAN_CHANGE_DRIVER_DISABLE_REQUEST_STATUS: 'userCanChangeDriverDisableRequestStatus',
  USER_CAN_EXPORT_SETTLEMENTS: 'userCanExportSettlements',
  USER_CAN_IMPORT_SETTLEMENTS: 'userCanImportSettlements',
  USER_CAN_MODIFY_PETROL_GROSS: 'userCanModifyPetrolGross',
  USER_CAN_MODIFY_RAVAPI_BONUS: 'userCanModifyRavapiBonus',
  USER_CAN_MODIFY_SETTLEMENT_APPLICATION: 'userCanModifySettlementApplication',
  USER_CAN_APPROVE_SETTLEMENTS: 'userCanApproveSettlements',
  USER_CAN_MOVE_SETTLEMENTS_BACK_TO_WAITING: 'userCanMoveSettleentsBackToWaiting',
  USER_CAN_DELETE_PAYOFF: 'userCanDeletePayoff',
  USER_CAN_CANCEL_PAYOFF: 'userCanCancelPayoff',
  USER_CAN_EXPORT_REQUEST_FOR_PAYMENT: 'canExportRequestForPayment',
  USER_HAVE_ACCESS_TO_REPORT_AREA: 'userHaveAccessToReportArea',
  USER_STATISTIC_BUNDLE: 'userGetStatisticBundleId',
  USER_ROLE: 'userRole',
  USER_ID: 'userId',
  ARTICLE_GROUPS: 'articleGroups',
  CONFIRM_IS_OPEN: 'confirmIsOpen',
  OPEN_SUPPORT_TICKETS_COUNT: 'openSupportTicketsCount',
  MESSAGE_NOTIFICATIONS: 'messageNotifications',
  UNREAD_MESSAGE_NOTIFICATIONS_COUNT: 'unreadMessageNotificationsCount',
  NOTIFICATION_SOUND_ENABLED: 'notificationSoundEnabled',
  SUPPORT_CHAT_POPUP_REQUEST: 'supportChatPopupRequest',
  VEHICLE_LOG_VISITED: 'vehicleLogVisited',
  USER_CAN_MASS_SET_VEHICLES_COMMISSION: 'canMassSetVehiclesCommission',
  USER_CAN_APPROVE_COLLIDING_SETTLEMENTS: 'canApproveCollidingSettlements',
  USER_CAN_MASS_ADJUST_SETTLEMENT_COMMISSIONS: 'canMassAdjustSettlementCommissions',
  USER_CAN_HOLDOFF_SETTLEMENT_PAYOFF:  'canHoldOffSettlementPayoff',
  USER_CAN_EXPORT_EQUIPMENT_RETURN_REQUEST: 'canExportEquipmentReturnRequest',
  USER_CAN_EXPORT_PROOF_OF_INCOME: 'userCanExportProofOfIncome',
  USER_CAN_REMOVE_DRIVER_CONTACT_FORM: 'userCanRemoveDriverContactForm',
  USER_CAN_EXPORT_PAYMENTS_SUMMARY_FOR_TAX: 'userCanExportPaymentsSummaryForTax',
  USER_CAN_CHANGE_STATE_EXCLUDE_FROM_EXPORT_SETTLEMENT: 'userCanChangeStateExcludeFromExportSettlement',
  USER_CAN_CREATE_INVOICE: 'userCanCreateInvoice',
  USER_CAN_MANUAL_EDIT_DRIVER_SUBJECT: 'userCanManualEditDriverSubject',
  USER_CAN_CHANGE_VEHICLE_IS_INCLUDED_IN_DAYOFF: 'userCanChangeVehicleIsIncludedInDayOff',
  USER_CAN_CHANGE_VEHICLE_COMMISSIONS: 'userCanChangeVehicleCommissions',
  USER_CAN_CHANGE_VEHICLE_DISCOUNTED_COMMISSIONS: 'canChangeVehicleDiscountedCommissions',
  USER_IS_EXCLUDED_FROM_VEHICLE_COMMISSIONS_REMINDER: 'isExcludedFromVehicleCommissionsReminder',
  USER_CAN_MANAGE_VEHICLE_DOCUMENTS: 'canManageVehicleDocuments',
  USER_CAN_IMPORT_PAYOFFS: 'userCanImportPayoffs',
  USER_CAN_ASSIGN_DIGITAL_PROMISSORY_NOTE_IN_RECEIVING_VEHICLE: 'userCanAssignDigitalPromissoryNoteInReceivingVehicle',
  USER_HAVE_ACCESS_TO_DIGITAL_DOCUMENTS_MANAGE_AREA: 'userHaveAccessToDigitalDocumentsManageArea',
  USER_CAN_CONFIRM_DRIVER_DOCUMENTS_WITHOUT_UPLOADING_FILE: 'canConfirmDriverDocumentsWithoutUploadingFile',
  USER_CAN_MANAGE_BONUS_CAMPAIGNS: 'userCanManageBonusCampaigns',
  USER_HAVE_ACCESS_TO_INVITE_PROGRAMS: 'userHaveAccessToInvitePrograms',
  USER_CAN_PUBLISH_INVITE_PROGRAM: 'userCanPublishInviteProgram',
  USER_CAN_DELETE_INVITE_PROGRAM_DRAFT: 'userCanDeleteInviteProgramDraft',
  USER_CAN_DELETE_INVITE_PROGRAM: 'userCanDeleteInviteProgram',
  USER_CAN_REMOVE_REFERRAL_PAYOFFS: 'userCanRemoveReferralPayoffs',
  USER_CAN_REMOVE_BLOCKING_WITHDRAW_DRIVER_STATUS_TAGS: 'canRemoveBlockingWithdrawDriverStatusTags',
  USER_CAN_SKIP_MISSING_VEHICLE_RENT_DIGITAL_DOCUMENTS_POPUP_REMINDER : 'canSkipMissingVehicleRentDigitalDocumentsPopupReminder',
  USER_CAN_VIEW_MISSING_DRIVERS_DIGITAL_DOCUMENTS: 'userCanViewMissingDriversDigitalDocuments',
  USER_CAN_CHANGE_STUDENT_VALIDATION_STATUS: 'userCanChangeStudentValidationStatus',
  USER_CAN_EDIT_DRIVER_CONTRACT_START_DATE: 'userCanEditDriverContractStartDate',
  USER_HAVE_ACCESS_TO_MAIL_AREA: 'userHaveAccessToMailArea',
  USER_CAN_ADD_OR_REMOVE_DRIVER_DAYOFF: 'userCanAddOrRemoveDriverDayoff',
  USER_CAN_MANAGE_MAIL_RULES: 'userCanManageMailRules',
  USER_HAVE_ACCESS_TO_ONLINE_PAYMENTS: 'userHaveAccessToOnlinePayments',
  USER_CAN_SEND_ONLINE_PAYMENT_REQUEST_TO_DEBTORS: 'userCanSendOnlinePaymentRequestToDebtors',
  USER_CAN_REMOVE_PAYU_PAYOFFS: 'userCanRemovePayUPayoffs',
  USER_CAN_REMOVE_ONLINE_PAYMENTS: 'userCanRemoveOnlinePayments',
  USER_CAN_SETTLE_DRIVER_VIA_ONLINE_PAYMENTS: 'userCanSettleDriverViaOnlinePayments',
  USER_CAN_EDIT_PAYOFF_ONLINE_PAYMENT: 'userCanEditPayoffOnlinePayment',
  USER_HAVE_ACCESS_TO_REFERRAL: 'userHaveAccessToReferral',
  USER_CAN_DELETE_REFERRAL: 'userCanDeleteReferral',
  USER_CAN_EDIT_REFERRAL: 'userCanEditReferral',
  USER_CAN_ADD_ONLINE_PAYMENT_INVOICE:'userCanAddOnlinePaymentInvoice',
  USER_CAN_EXPORT_DRIVERS_TO_CSV: 'userCanExportDriversToCsv',
  USER_CAN_APPROVE_MASS_CAMPAIGNS: 'userCanApproveMassCampaigns',
  USER_HAVE_ACCESS_TO_MASS_CAMPAIGNS: 'userHaveAccessToMassCampaigns',
  USER_HAVE_FULL_ACCESS_TO_EDIT_MASS_CAMPAIGNS: 'userHaveFullAccessToEditMassCampaigns',
  USER_CAN_SEND_DRIVER_DATA_TO_FLOVI: 'userCanSendDriverDataToFlovi',
  USER_HAVE_ACCESS_TO_EXPORT_DEBTORS_FOR_PENALTY_SUMMARY: 'userHaveAccessToExportDebtorsForPenaltySummary',
  USER_HAVE_ACCESS_TO_EXPORTS_AREA: 'userHaveAccessToExportsArea',
  USER_CAN_EXPORT_SETTLEMENTS_REPORT: 'userCanExportSettlementsReport',
  USER_CAN_EXPORT_VEHICLE_PAID_RENT: 'userCanExportVehiclePaidRent',
  USER_CAN_EXPORT_WORK_LOG: 'userCanExportWorkLog',
  USER_CAN_EXPORT_TAKEN_CASH_FROM_SETTLEMENTS: 'userCanExportTakenCashFromSettlements',
  USER_CAN_EXPORT_USER_WITHDRAW_SUMMARY: 'userCanExportUserWithdrawSummary',
  USER_CAN_MASS_DELETE_PAYOFFS: 'userCanMassDeletePayoffs',
  USER_CAN_MASS_REMOVE_DRIVERS_FROM_SII: 'userCanMassRemoveDriversFromSII',
  USER_CAN_MASS_REPORT_DRIVERS_TO_SII: 'userCanMassReportDriversToSII',
  USER_CAN_MANAGE_VEHICLE_CASHBACK: 'userCanManageVehicleCashback',
  USER_CAN_EXPORT_PAYOFFS: 'userCanExportPayoffs',
  USER_CAN_CHANGE_MOBILE_APP_DRIVER_FILE_VISIBILITY: 'userCanChangeMobileApplicationDriverFileVisibility',
  USER_CAN_SEND_INVOICE_TO_KSEF: 'userCanSendInvoiceToKSeF',
  USER_CAN_CLAIM_SUPPORT_TICKET: 'userCanClaimSupportTicket',
  USER_CAN_TAKE_OVER_SUPPORT_TICKET: 'userCanTakeOverSupportTicket',
  USER_CAN_CLOSE_SUPPORT_TICKET: 'userCanCloseSupportTicket',
  USER_CAN_DELETE_SUPPORT_TICKET: 'userCanDeleteSupportTicket',
  USER_CAN_MASS_DELETE_SUPPORT_TICKETS: 'userCanMassDeleteSupportTickets',
  USER_HAVE_ACCESS_TO_AI_KNOWLEDGE_BASE: 'userHaveAccessToAiKnowledgeBase',
  USER_CAN_MANAGE_AI_KNOWLEDGE_BASE: 'userCanManageAiKnowledgeBase',
  USER_CAN_MASS_CANCEL_SII_PAYOFFS: 'userCanMassCancelSiiPayoffs',
  USER_CAN_FORCE_RAVAPI_PAYMENTS_TITLE: 'userCanForceRavapiPaymentsTitle',
  USER_CAN_MASS_ADD_SII_PAYOFFS: 'userCanMassAddSiiPayoffs',
  KSEF_ENABLED: 'ksefEnabled',
};

export const ACTIONS = {
  GET_USER_INFO: 'getUserInfo',
  GET_ARTICLE_GROUPS: 'getArticleGroups',
  GET_KSEF_CONFIG: 'getKSeFConfig',
  START_DRIVER_CHAT_HUB: 'startDriverChatHub',
  STOP_DRIVER_CHAT_HUB: 'stopDriverChatHub',
  GET_OPEN_SUPPORT_TICKETS_COUNT: 'getOpenSupportTicketsCount',
  GET_MESSAGE_NOTIFICATIONS: 'getMessageNotifications',
  CHANGE_MESSAGE_NOTIFICATION_IS_READ: 'changeMessageNotificationIsRead',
  CHANGE_ALL_MESSAGE_NOTIFICATIONS_READ: 'changeAllMessageNotificationsRead',
};

export const MUTATIONS = {
  SET_INITIALIZED: 'setInitialized',
  SET_LOADING: 'setLoading',
  SHOW_SNACKBAR_MESSAGE: 'showSnackbarMessage',
  SHOW_CONFIRM: 'showConfirm',
  FINISH_CONFIRM: 'finishConfirm',
  SHOW_REASON_PROMPT: 'showReasonPrompt',
  FINISH_REASON_PROMPT: 'finishReasonPrompt',
  SET_USER_INFO: 'setUserInfo',
  SET_ARTICLE_GROUPS: 'setArticleGroups',
  VISIT_VEHICLE_LOG: 'visitVehicleLog',
  SHOW_ONCE_DIALOG: 'showOnceDialog',
  HIDE_ONCE_DIALOG: 'hideOnceDialog',
  SET_KSEF_ENABLED: 'setKSeFEnabled',
  SET_OPEN_SUPPORT_TICKETS_COUNT: 'setOpenSupportTicketsCount',
  SET_MESSAGE_NOTIFICATIONS: 'setMessageNotifications',
  ADD_MESSAGE_NOTIFICATION: 'addMessageNotification',
  SET_MESSAGE_NOTIFICATION_IS_READ: 'setMessageNotificationIsRead',
  SET_ALL_MESSAGE_NOTIFICATIONS_READ: 'setAllMessageNotificationsRead',
  SET_NOTIFICATION_SOUND_ENABLED: 'setNotificationSoundEnabled',
  REQUEST_SUPPORT_CHAT_POPUP: 'requestSupportChatPopup',
};
